import axios from "axios";

// 🔹 Axios instance
const api = axios.create({
  baseURL: window.location.origin.includes('localhost') ?  "https://brtravels.co.in/api": window.location.origin + "/api",
  headers: {
    "Accept": "application/json"
  }
});



/* =========================
   🔐 AUTH
========================= */

export const login = (email, password) => {
  return api.post("/auth/login.php", {
    email,
    password
  });
};

/* =========================
   📩 CONTACT / LEADS
========================= */

export const createLead = (data) => {
  const formData = new FormData();
  formData.append("name", data.name);
  formData.append("email", data.email);
  formData.append("phone", data.phone);
  formData.append("subject", data.subject);
  formData.append("message", data.message);

  return api.post("/leads/leadscreate.php", formData);
};

export const getLeads = () => {
  return api.get("/leads/leadlist.php");
};

/* =========================
   ✈️ TRAVEL ENQUIRY
========================= */

export const createEnquiry = (data) => {
  const formData = new FormData();
  formData.append("name", data.name);
  formData.append("email", data.email);
  formData.append("phone", data.phone);
  formData.append("destination", data.destination);
  formData.append("message", data.message);

  return api.post("/leads/enquirycreate.php", formData);
};

export const getEnquiries = () => {
  return api.get("/leads/enquirylist.php");
};

/* =========================
   🖼️ GALLERY
========================= */

export const getGalleryFolders = () => {
  return api.get("/gallery/folders.php");
};


/* =========================
   🖼️ GALLERY (✅ NEW)
========================= */

/* 🔹 Get Folder List (including empty folders) */
export const getGalleryFolderList = () => {
  return api.get("/gallery/folder-list.php");
};

/* 🔹 Create Folder */
export const createGalleryFolder = (folder) => {
  return api.get("/gallery/create_folder.php", {
    params: { folder },
  });
};

/* 🔹 Delete Folder */
export const deleteGalleryFolder = (folder) => {
  return api.get("/gallery/delete_folder.php", {
    params: { folder },
  });
};

/* 🔹 Rename Folder */
export const renameGalleryFolder = (oldName, newName) => {
  return api.get("/gallery/rename_folder.php", {
    params: {
      folder: oldName,
      newName: newName,
    },
  });
};

/* 🔹 Upload Images */
export const uploadGalleryImages = (folder, files) => {
  const formData = new FormData();
  formData.append("folder", folder);

  files.forEach((file) => {
    formData.append("images[]", file);
  });

  return api.post("/gallery/upload_image.php", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

/* 🔹 Get Images of Folder */
export const getGalleryImages = (folder) => {
  return api.get("/gallery/images.php", {
    params: { folder },
  });
};

/* 🔹 Delete Images */
export const deleteGalleryImages = (folder, images) => {
  return api.post(
    "/gallery/delete_images.php",
    {
      folder,
      images,
    },
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
};

export default api;
